/**
 * Label of the time-to-submit bucket that starts at `start` hours: `0–6h` ... `36–48h`, and
 * `48h+` for the last, open-ended one.
 */
export const hourBucketLabel = (start: number, starts: readonly number[]): string => {
  const next = starts[starts.indexOf(start) + 1];
  return starts.includes(start) && next !== undefined ? `${start}–${next}h` : `${start}h+`;
};
